import * as React from 'react';
import { ITopJK, ITopThreeItem } from '../../types/top_three';
import { MortgageLandingContainer } from '../../containers/MortgageLandingContainer';
import { TopNewbuildingBlockContainer } from '../../containers/TopNewbuildingBlock';
import { SeoContainer } from '../../containers/seo_container';
import { FiltersContainer } from '../filters_container/filters_container';
import { Specialists } from '../../containers/specialists/specialists';
import { VacanciesContainer } from '../../containers/vacancies/vacancies';
import { VerticalPromo } from '../../containers/vertical_promo/vertical_promo';
import { CommercialPromo } from '../../containers/commercial_promo/commercial_promo';
import { TwoColumnContainer } from '../two_column_container/two_column_container';
import { NewBuildingsServices } from '../../containers/new_buildings_service/new_buildings_services';
import { MagazineContainer } from '../../containers/magazine/magazine';
import { Filters } from '../../containers/search_block/filters';
import { SaleServices } from '../../containers/sale_services/sale_services';
import { Promo } from '../../containers/promo/promo';
import { PopularList } from '../../containers/popular_list/popular_list';
import { JKPopularList } from '../../containers/popular_jk/popular_jk';
import { NewBuildingCaption } from '../../containers/new_building_caption/new_building_caption';
import { SalesLinksContainer } from '../../containers/SalesLinksContainer';
import { GeoSwitcherWrapperContainer } from '../../containers/GeoSwitcherContainer';
import { RecommendationsContainer } from '../../containers/RecommendationsContainer';

export interface IHomeComponentProps {
  isMortgageTabActive: boolean;
  isFetching: boolean;
  top3?: ITopThreeItem[];
  popularJks?: ITopJK[];
  section: string;
}

export class HomeComponent extends React.Component<IHomeComponentProps> {
  public renderPromo() {
    switch (this.props.section) {
      case 'index':
        return <Promo />;
      case 'daily-rent':
      case 'sale':
      case 'rent':
      case 'new-buildings':
        return <VerticalPromo />;
      case 'commercial':
        return <CommercialPromo />;
      default:
        return null;
    }
  }

  public renderServices() {
    switch (this.props.section) {
      case 'daily-rent':
      case 'commercial':
      case 'sale':
      case 'rent':
        return <SaleServices />;
      case 'new-buildings':
        return <NewBuildingsServices />;
      case 'index':
      default:
        return null;
    }
  }

  public renderPopular() {
    if (this.props.section === 'new-buildings') {
      return <JKPopularList services={this.renderServices()} />;
    } else {
      return <PopularList showLinkToAll={this.props.section !== 'index'} services={this.renderServices()} />;
    }
  }

  public render() {
    const { section, isMortgageTabActive, isFetching } = this.props;
    const isIndexSection = section === 'index';

    if (isFetching) {
      return null;
    }

    if (isMortgageTabActive) {
      return (
        <div>
          <GeoSwitcherWrapperContainer />
          <FiltersContainer>
            <NewBuildingCaption section={section} />
            <Filters section={section} />
          </FiltersContainer>
          <MortgageLandingContainer />
        </div>
      );
    } else {
      return (
        <div>
          <GeoSwitcherWrapperContainer />
          <FiltersContainer>
            <NewBuildingCaption section={section} />
            <Filters section={section} />
          </FiltersContainer>

          {isIndexSection && <TopNewbuildingBlockContainer />}

          <SalesLinksContainer section={section} />

          {this.renderPromo()}

          <RecommendationsContainer />

          <TwoColumnContainer wideRow={section === 'commercial'} popularPresented={this.popularPresented()}>
            {this.renderPopular()}
            <Specialists section={section} popularPresented={this.popularPresented()} />
          </TwoColumnContainer>

          {isIndexSection && (
            <>
              <MagazineContainer />
              <VacanciesContainer />
            </>
          )}

          <SeoContainer />
        </div>
      );
    }
  }

  private popularPresented() {
    return (
      (!!this.props.top3 && this.props.top3.length > 0) || (!!this.props.popularJks && this.props.popularJks.length > 0)
    );
  }
}
